<template>
	<div class="col-md-12" style="margin-top: 3%">
		<v-container>
			<v-layout row wrap>
				<v-flex lg6 md6 sm12 xs12>
					<v-container>
						<v-dialog
							ref="dialog1"
							persistent
							v-model="modal1"
							lazy
							full-width
							width="290px"
							:return-value.sync="facility.start_date"
							v-if="route === 'Reservation' || route === 'NewPartnerBooking'"
						>
							<v-text-field
								slot="activator"
								label="Start Date"
								v-model="facility.start_date"
								readonly
							></v-text-field>
							<v-date-picker
								v-model="facility.start_date"
								scrollable
								:min="today"
								@input="resetForAvailability()"
							>
								<v-spacer></v-spacer>
								<v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
								<v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(facility.start_date)">OK</v-btn>
							</v-date-picker>
						</v-dialog>
						<v-menu
							ref="dialog1"
							v-model="dialog1"
							:close-on-content-click="false"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							max-width="290px"
							min-width="290px"
							v-if="route === 'NewBooking' || route === 'EditBooking'"
						>
							<template slot="activator">
								<v-text-field
									v-model="facility.start_date"
									label="Start Date"
									hint="YYYY/MM/DD"
									persistent-hint
									v-if="route === 'NewBooking' || route === 'EditBooking'"
									:min="facility.start_date"
									
								></v-text-field>
							</template>
							<v-date-picker color="primary" v-model="facility.start_date" :min="today" @input="resetForAvailability()" no-title></v-date-picker>
						</v-menu>
		 
					</v-container>
				</v-flex>
				<v-flex lg6 md6 sm12 xs12>
					<v-container v-if="facility.start_date !== ''">
						<v-dialog
							ref="dialog2"
							persistent
							v-model="modal2"
							lazy
							full-width
							width="290px"
							:return-value.sync="facility.end_date"
							v-if="route === 'Reservation' || route === 'NewPartnerBooking'"
						>
							<v-text-field
								slot="activator"
								label="End Date"
								v-model="facility.end_date"
								readonly
								v-if="route === 'Reservation' || route === 'NewPartnerBooking'"
							></v-text-field>
							<v-date-picker
								v-model="facility.end_date"
								scrollable
								:min="facility.start_date"
								@input="searchFacilityAvailability()"
							>
								<v-spacer></v-spacer>
								<v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
								<v-btn :depressed="true" flat color="primary" @click="$refs.dialog2.save(facility.end_date)">OK</v-btn>
							</v-date-picker>
						</v-dialog>
						<v-menu
							ref="enddialog2"
							v-model="booking_update_dialog2"
							:close-on-content-click="false"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							max-width="290px"
							min-width="290px"
							v-if="route === 'NewBooking' || route === 'EditBooking'"
						>
							<template slot="activator">
								<v-text-field
									v-model="facility.end_date"
									label="End Date"
									hint="YYYY/MM/DD"
									persistent-hint
									v-if="route === 'NewBooking' || route === 'EditBooking'"
									:min="facility.start_date"
								></v-text-field>
							</template>
							<v-date-picker color="primary" v-model="facility.end_date" :min="facility.start_date" @input="searchFacilityAvailability()" no-title></v-date-picker>
						</v-menu>
				
					</v-container>
				</v-flex>
				<v-flex lg4 md4 sm6 xs12>
					<v-container
						fluid
						v-if="facility.start_date !== '' && facility.end_date !== ''"
					>
						<v-autocomplete
							label="Accommodation"
							v-model="facility.accommodation"
							:items="allAvailabileFacilities"
							@change="getFacility"
							:rules="[v => !!v || 'Item is required']"
							required
							item-text="name"
							:return-object="true"
							item-value="accommodation"
							:loading="$loadingTrue"
						></v-autocomplete>
					</v-container>
				</v-flex>
				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="
						facility.start_date !== '' &&
							facility.end_date !== '' &&
							facility.accommodation.accomodation_type_id === 'Pelican'
					"
				>
					<v-container>
						<v-select
							label="Catering Type"
							v-model="facility.catering_type"
							:items="cateringType"
							:rules="[v => !!v || 'Item is required']"
							required
							item-text="facility_pricing_name"
							item-value="facility_pricing_type_public_id"
						></v-select>
					</v-container>
				</v-flex>
				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="
						(facility.start_date !== '' &&
							facility.end_date !== '' &&
							facility.accommodation.accomodation_type_id === 'Stables' &&
							facility.accommodation.name ===
								'The Stables Research Centre - Double Room (One Bed)') ||
							facility.accommodation.name ===
								'The Stables Research Centre - Twin Room (Two Beds)'
					"
				>
					<v-container>
						<v-select
							label="Number of Rooms"
							v-model="facility.number_of_rooms"
							:items="roomSlots"
							:rules="[v => !!v || 'Item is required']"
							required
						></v-select>
					</v-container>
				</v-flex>
				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="facility.start_date !== '' && facility.end_date !== ''"
				>
					<v-container>
						<v-autocomplete
							label="Children"
							:items="childSlots"
							v-model="facility.children"
							no-data-text="No Slots Available"
							v-if="addedMultiArrivals.length === 0"
						></v-autocomplete>
					</v-container>
				</v-flex>
				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="facility.start_date !== '' && facility.end_date !== ''"
				>
					<v-container>
						<v-autocomplete
							label="Adults"
							:items="adultSlots"
							v-model="facility.adults"
							no-data-text="No Slots Available"
							v-if="addedMultiArrivals.length === 0"
						></v-autocomplete>
					</v-container>
				</v-flex>
				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="
						(route === 'NewBooking' || route === 'EditBooking') &&
							facility.start_date !== '' &&
							facility.end_date !== '' &&
							addedMultiArrivals.length === 0
					"
				>
					<v-container>
						<v-text-field
							label="Discount (%)"
							type="number"
							v-model="facility.accommodation_discount"
							v-if="
								(route === 'NewBooking' || route === 'EditBooking') &&
									facility.start_date !== '' &&
									facility.end_date !== '' &&
									addedMultiArrivals.length === 0
							"
						></v-text-field>
					</v-container>
				</v-flex>

				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="
						(facility.accommodation.has_extras === true &&
							route === 'NewBooking') ||
							(route === 'EditBooking' &&
								facility.start_date !== '' &&
								facility.end_date !== '')
					"
				>
					<v-container>
						<v-text-field
							label="Extra Adults"
							type="number"
							v-model="facility.extra_pax_adults"
							v-if="
								(facility.accommodation.has_extras === true &&
									facility.accommodation.accomodation_type === 'Stables') ||
									facility.accommodation.accomodation_type === null ||
									(facility.accommodation.accomodation_type === undefined &&
										facility.start_date !== '' &&
										facility.end_date !== '')
							"
						></v-text-field>
					</v-container>
				</v-flex>

				<v-flex
					lg3
					md3
					sm6
					xs12
					fluid
					v-if="
						(facility.accommodation.has_extras === true &&
							route === 'NewBooking') ||
							(route === 'EditBooking' &&
								facility.start_date !== '' &&
								facility.end_date !== '')
					"
				>
					<v-container>
						<v-text-field
							label="Extra Children"
							type="number"
							v-model="facility.extra_pax_children"
							v-if="
								(facility.accommodation.has_extras === true &&
									facility.accommodation.accomodation_type === 'Stables') ||
									facility.accommodation.accomodation_type === null ||
									(facility.accommodation.accomodation_type === undefined &&
										facility.start_date !== '' &&
										facility.end_date !== '')
							"
						></v-text-field>
					</v-container>
				</v-flex>

				<v-flex
					lg4
					md4
					v-if="
						(is_camping === true && route === 'NewBooking') ||
							route === 'EditBooking'
					"
				>
					<v-container>
						<v-btn
							color="info"
							dark
							@click="dialog = true"
							v-if="
								facility.accommodation.facility_type_id === 'Camping Sites' &&
									route === 'NewBooking'
							"
							>Set Multi Arrivals</v-btn
						>
						<v-btn
							color="info"
							dark
							@click="dialog = true"
							v-else-if="
								route === 'EditBooking' &&
									facility.start_date !== '' &&
									facility.accommodation.facility_type_id === 'Camping Sites'
							"
							>Set Multi Arrivals</v-btn
						>
					</v-container>

					<v-dialog
						v-model="dialog"
						fullscreen
						hide-overlay
						transition="dialog-bottom-transition"
						scrollable
					>
						<v-card tile>
							<v-toolbar card dark color="primary">
								<v-btn icon dark @click="dialog = false">
									<v-icon>close</v-icon>
								</v-btn>
								<v-toolbar-title>Camping Multi-Arrivals</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<v-card-text>
								<v-list three-line subheader>
									<v-subheader>Choose Arrival Dates</v-subheader>
									<v-layout row wrap>
										<v-flex lg3 md4 sm12 xs12>
											<v-container>
												<v-dialog
													ref="dialog1"
													persistent
													v-model="modal1"
													lazy
													full-width
													width="290px"
													:return-value.sync="multi.start_date"
													v-if="
														route === 'NewBooking' || route === 'EditBooking'
													"
												>
													<v-text-field
														slot="activator"
														label="Start Date"
														v-model="multi.start_date"
														readonly
													></v-text-field>
													<v-date-picker
														v-model="multi.start_date"
														scrollable
														:min="facility.start_date"
													>
														<v-spacer></v-spacer>
														<v-btn
															:depressed="true"
															flat
															color="primary"
															@click="modal1 = false"
															>Cancel</v-btn
														>
														<v-btn
															:depressed="true"
															flat
															color="primary"
															@click="$refs.dialog1.save(multi.start_date)"
															>OK</v-btn
														>
													</v-date-picker>
												</v-dialog>
											</v-container>
										</v-flex>
										<v-flex lg3 md4 sm12 xs12>
											<v-container>
												<v-dialog
													ref="dialog2"
													persistent
													v-model="modal2"
													lazy
													full-width
													width="290px"
													:return-value.sync="multi.end_date"
												>
													<v-text-field
														slot="activator"
														label="End Date"
														v-model="multi.end_date"
														readonly
													></v-text-field>
													<v-date-picker
														v-model="multi.end_date"
														scrollable
														:min="multi.start_date"
													>
														<v-spacer></v-spacer>
														<v-btn
															:depressed="true"
															flat
															color="primary"
															@click="modal2 = false"
															>Cancel</v-btn
														>
														<v-btn
															:depressed="true"
															flat
															color="primary"
															@click="$refs.dialog2.save(multi.end_date)"
															>OK</v-btn
														>
													</v-date-picker>
												</v-dialog>
											</v-container>
										</v-flex>
										<v-flex lg3 md4 sm12 xs12>
											<v-container>
												<v-text-field
													label="Adults"
													type="number"
													v-model="multi.adults"
												></v-text-field>
											</v-container>
										</v-flex>
										<v-flex lg3 md4 sm12 xs12>
											<v-container>
												<v-text-field
													label="Children"
													type="number"
													v-model="multi.children"
												></v-text-field>
											</v-container>
										</v-flex>
										<v-flex lg3 md4 sm12 xs12>
											<v-container>
												<v-text-field
													label="Discount (%)"
													type="number"
													v-model="multi.discount"
												></v-text-field>
											</v-container>
										</v-flex>
										<v-flex lg4 md4 sm12 xs12>
											<v-container>
												<v-switch
													color="primary"
													label="Expected to pay"
													v-model="multi.expected_to_pay"
												></v-switch>
											</v-container>
										</v-flex>
										<v-flex lg4 md4 sm12 xs12>
											<v-btn color="primary" block @click="addCampingArrival"
												>Add Entry</v-btn
											>
										</v-flex>
									</v-layout>
									<v-layout row wrap></v-layout>
								</v-list>
								<v-divider></v-divider>
								<table class="table table-bordered">
									<thead>
										<tr>
											<th>Dates</th>
											<th>Children</th>
											<th>Adults</th>
											<th>Discount</th>
											<th>Total Amount</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(facility, key) in addedMultiArrivals"
											:key="key"
										>
											<td>
												{{ facility.start_date }} - {{ facility.end_date }}
											</td>
											<td>{{ facility.children }}</td>
											<td>{{ facility.adults }}</td>
											<td>{{ facility.discount }}%</td>
											<td>
												{{ currency }}
												{{ $roundOff(multiArrivalsTotal(facility)) }}
											</td>
											<td>
												<v-btn
													:depressed="true"
													small
													color="error"
													@click="removeMultiArrival(facility)"
													>x</v-btn
												>
											</td>
										</tr>
									</tbody>
								</table>
								<v-flex lg4 md4>
									<v-container>
										<v-btn color="primary" @click="confirmArrivals"
											>Confirm Arrivals</v-btn
										>
									</v-container>
								</v-flex>
							</v-card-text>
							<div style="flex: 1 1 auto"></div>
						</v-card>
					</v-dialog>
				</v-flex>

				<v-container v-if="route !== 'PostponeBooking'">
					<v-btn :depressed="true" color="primary" @click="addAccommodation()"
						>Add to Booking</v-btn
					>
					<v-btn
						color="info"
						dark
						@click="dialog13 = true"
						v-if="route === 'NewBooking' || route === 'EditBooking'"
						>Ol pejeta Escapes</v-btn
					>
					<v-dialog
						v-model="dialog13"
						fullscreen
						hide-overlay
						transition="dialog-bottom-transition"
					>
						<v-card tile style="">
							<v-toolbar card dark color="primary">
								<v-btn icon dark @click="dialog13 = false">
									<v-icon>close</v-icon>
								</v-btn>
								<v-toolbar-title>Ol pejeta Escapes Booking</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<v-container>
								<v-card-text>
									<v-list three-line subheader>
										<v-subheader>Choose Dates</v-subheader>
										<v-layout row wrap>
											<v-flex lg4 md4 sm12 xs12>
												<v-container>
													<v-dialog
														ref="dialog11"
														persistent
														v-model="modal11"
														lazy
														full-width
														width="290px"
														:return-value.sync="external_facility.start_date"
														v-if="
															route === 'NewBooking' || route === 'EditBooking'
														"
													>
														<v-text-field
															slot="activator"
															label="Start Date"
															v-model="external_facility.start_date"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="external_facility.start_date"
															scrollable
															:min="today"
														>
															<v-spacer></v-spacer>
															<v-btn
																:depressed="true"
																flat
																color="primary"
																@click="modal11 = false"
																>Cancel</v-btn
															>
															<v-btn
																:depressed="true"
																flat
																color="primary"
																@click="
																	$refs.dialog11.save(
																		external_facility.start_date
																	)
																"
																>OK</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-container>
											</v-flex>
											<v-flex lg4 md4 sm12 xs12>
												<v-container>
													<v-dialog
														ref="dialog12"
														persistent
														v-model="modal12"
														lazy
														full-width
														width="290px"
														:return-value.sync="external_facility.end_date"
													>
														<v-text-field
															slot="activator"
															label="End Date"
															v-model="external_facility.end_date"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="external_facility.end_date"
															scrollable
															@input="searchExternalFacilityAvailability()"
															:min="external_facility.start_date"
														>
															<v-spacer></v-spacer>
															<v-btn
																:depressed="true"
																flat
																color="primary"
																@click="modal12 = false"
																>Cancel</v-btn
															>
															<v-btn
																:depressed="true"
																flat
																color="primary"
																@click="
																	$refs.dialog12.save(external_facility.end_date)
																"
																>OK</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-container>
											</v-flex>
											<v-flex lg4 md4 sm12 xs12>
												<v-container>
													<v-autocomplete
														label="Accommodation"
														v-model="external_facility.accommodation"
														:items="allAvailableExternalFacilities"
														@change="getExternalFacility"
														:rules="[v => !!v || 'Item is required']"
														required
														item-text="name"
														:return-object="true"
														item-value="accommodation"
														:loading="$loadingTrue"
													></v-autocomplete>
												</v-container>
											</v-flex>
											<br />
											<br />
											<v-flex
												lg12
												md12
												sm12
												xs12
												v-if="
													external_facility.start_date !== '' &&
														external_facility.end_date !== ''
												"
											>
												<v-container>
													<table class="table table-bordered">
														<thead>
															<tr>
																<th>Parameter Name</th>
																<th>Value</th>
																<th>Price</th>
																<th>Discount</th>
																<th>Supplement Prices</th>
																<th>Other Prices</th>
																<th>Total Amount</th>
															</tr>
														</thead>
														<tbody>
															<tr
																v-for="(facility,
																key) in externalFacilityPricing"
																:key="key"
															>
																<td>
																	{{ facility.facility_parameter_name }}
																</td>

																<td>
																	<v-text-field
																		label="Number"
																		type="number"
																		min="0"
																		v-model="
																			externalFacilityPricing[key]
																				.parameter_default_value
																		"
																	></v-text-field>
																</td>

																<td v-if="facility.facility_pricing_point == 1">
																	{{ currency }}
																	{{
																		$roundOff(
																			convert1(
																				facility.prices.currency_type,
																				facility.prices.mandatory_price
																			).amount
																		)
																	}}
																</td>
																<td v-else>
																	N/A
																</td>

																<td v-if="facility.facility_pricing_point == 1">
																	<v-text-field
																		label="Discount (%)"
																		type="number"
																		:rules="limitRules"
																		min="0"
																		max="100"
																		v-model="
																			externalFacilityPricing[key]
																				.accommodation_discount
																		"
																		required
																	></v-text-field>
																</td>
																<td v-else>
																	N/A
																</td>
																<td v-if="facility.facility_pricing_point == 1">
																	<v-switch
																		v-for="(supPrice,
																		key) in facility.supplement_price"
																		:key="key"
																		color="primary"
																		:label="
																			supPrice.facility_extra_pricing_name
																		"
																		v-model="supPrice.is_include"
																		@change="setSwitchesForItem(supPrice)"
																		required
																	></v-switch>
																</td>
																<td v-else>
																	N/A
																</td>
																<td
																	v-if="
																		facility.non_priced_parameter.length > 0
																	"
																>
																	<p
																		v-for="(non_price,
																		key) in facility.non_priced_parameter"
																		:key="key"
																	>
																		<v-text-field
																			:label="non_price.facility_parameter_name"
																			type="number"
																			min="0"
																			v-model="
																				non_price.parameter_default_value
																			"
																		></v-text-field>
																	</p>
																</td>
																<td v-else>
																	N/A
																</td>
																<td v-if="facility.facility_pricing_point == 1">
																	<b
																		>{{ $localCurrency }}
																		{{
																			$roundOff(
																				externalFacilityPricing[key]
																					.parameter_default_value *
																					((100 -
																						externalFacilityPricing[key]
																							.accommodation_discount) /
																						100) *
																					convert1(
																						externalFacilityPricing[key].prices
																							.currency_type,
																						externalFacilityPricing[key].prices
																							.mandatory_price
																					).amount +
																					externalFacilityPricing[key]
																						.parameter_default_value *
																						convert1(
																							externalFacilityPricing[key]
																								.supplement_sum.currency_type,
																							externalFacilityPricing[key]
																								.supplement_sum.amount
																						).amount
																			)
																		}}</b
																	>
																</td>
																<td v-else>
																	N/A
																</td>
															</tr>
															<tr>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td>
																	<h3>
																		<strong
																			>{{ $localCurrency }}
																			{{
																				$roundOff(accommodationTotal)
																			}}</strong
																		>
																	</h3>
																</td>
															</tr>
														</tbody>
													</table>
												</v-container>
											</v-flex>
											<v-flex lg4 md4 sm12 xs12>
												<v-container>
													<v-btn color="primary" @click="addExternalEntry"
														>Add Entry</v-btn
													>
												</v-container>
											</v-flex>

											<v-flex lg12 md12 sm12 xs12>
												<v-container>
													<table class="table table-bordered">
														<thead>
															<tr>
																<th>Dates</th>
																<th>Accomodation</th>
																<th>Parameter Name</th>
																<th>Value</th>
																<th>Discount</th>
																<th>Percent Commission</th>
																<th>Extra Price</th>
																<th>Total Amount</th>
																<th>Action</th>
															</tr>
														</thead>
														<tbody>
															<tr
																v-for="(facility, key) in addedExternalFacility"
																:key="key"
															>
																<td>
																	{{ facility.start_date }} -
																	{{ facility.end_date }}
																</td>
																<td>{{ facility.name }}</td>
																<td>
																	{{ facility.facility_parameter_name }}

																	<p
																		class="m-0 grey--text"
																		v-for="(supPrice,
																		key) in facility.non_priced_parameter"
																		:key="key"
																	>
																		{{ supPrice.facility_parameter_name }}:{{
																			supPrice.parameter_default_value
																		}}
																	</p>
																</td>

																<td v-if="facility.facility_pricing_point == 1">
																	{{ facility.parameter_default_value }}
																	<b>@</b> {{ currency }}
																	{{
																		$roundOff(
																			convert1(
																				facility.prices.currency_type,
																				facility.prices.mandatory_price
																			).amount
																		)
																	}}
																	<b>x</b>
																	{{
																		getDays(
																			facility.start_date,
																			facility.end_date
																		)
																	}}
																	Nights
																</td>

																<td v-else>
																	{{ facility.parameter_default_value }}
																</td>
																<td>{{ facility.accommodation_discount }}%</td>
																<td>{{ facility.percentage_commission }}%</td>

																<td>
																	<p
																		v-for="(supPrice,
																		key) in facility.supplement_price"
																		:key="key"
																	>
																		<span v-if="supPrice.is_include == true">
																			{{ supPrice.facility_extra_pricing_name
																			}}<span class="grey--text"
																				>({{ currency }}
																				{{
																					$roundOff(
																						convert1(
																							supPrice.currency_type,
																							supPrice.amount
																						).amount
																					)
																				}}
																				x
																				{{ facility.parameter_default_value }}
																				<b>x</b>
																				{{
																					getDays(
																						facility.start_date,
																						facility.end_date
																					)
																				}}
																				Nights)</span
																			>
																		</span>
																	</p>
																</td>
																<td>
																	<b>
																		{{ $localCurrency }}
																		{{
																			$roundOff(
																				getDays(
																					facility.start_date,
																					facility.end_date
																				) *
																					(facility.parameter_default_value *
																						((100 -
																							facility.accommodation_discount) /
																							100) *
																						convert1(
																							facility.prices.currency_type,
																							facility.prices.mandatory_price
																						).amount +
																						facility.parameter_default_value *
																							convert1(
																								facility.supplement_sum
																									.currency_type,
																								facility.supplement_sum.amount
																							).amount)
																			)
																		}}
																	</b>
																</td>
																<td>
																	<v-btn
																		:depressed="true"
																		small
																		color="error"
																		@click="removeExternalFacility(facility)"
																		>x</v-btn
																	>
																</td>
															</tr>
														</tbody>
													</table>

													<v-flex lg4 md4 sm12 xs12>
														<v-container>
															<v-btn
																color="primary"
																@click="confirmExternalBooking"
																>Confirm Bookings</v-btn
															>
														</v-container>
													</v-flex>
												</v-container>
											</v-flex>
										</v-layout>
									</v-list>
								</v-card-text>
							</v-container>
						</v-card>
					</v-dialog>
				</v-container>
			</v-layout>
			<v-flex
				lg3
				v-if="
					route === 'NewBooking' ||
						route === 'NewPartnerBooking' ||
						route === 'EditBooking' ||
						route === 'PostponeBooking'
				"
			>
				<h4 style="margin-left: 5%" class="earth-color">
					AVAILABLE SLOTS : {{ Number(this.AvailablefacilitySlots) }}
				</h4>
			</v-flex>
			<v-container>
				<br />
				<br />
				<v-flex
					lg3
					v-if="
						route === 'NewBooking' ||
							route === 'NewPartnerBooking' ||
							route === 'EditBooking'
					"
				>
					<h4 style="margin-left: 5%" class="earth-color">New Bookings</h4>
				</v-flex>

				<div
					class="col-md-12"
					v-if="
						route === 'NewPartnerBooking' ||
							route === 'EditBooking' ||
							route === 'NewBooking'
					"
				>
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Accommodation</th>
								<th>Type</th>
								<th>Dates</th>
								<th>Extra Pax</th>
								<th>Children</th>
								<th>Adults</th>
								<th>Discount</th>
								<th>Total Amount</th>
								<th>Action</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(facility, key) in chosenFacilities" :key="key">
								<td>{{ facility.name }}</td>
								<td>{{ facility.facility_type }}</td>
								<td>{{ facility.start_date }} - {{ facility.end_date }}</td>
								<td>
									Adults : {{ facility.extra_pax_adults }} Children:
									{{ facility.extra_pax_children }}
								</td>
								<td>{{ facility.children }}</td>
								<td>{{ facility.adults }}</td>
								<td>{{ facility.accommodation_discount }}%</td>
								<td v-if="facility.external">
									{{ $localCurrency }}
									{{ $roundOff(externalFacilityTotal(facility)) }}
								</td>
								<td v-else>
									{{ $localCurrency }} {{ $roundOff(facilityTotal(facility)) }}
								</td>
								<td>
									<v-btn
										:depressed="true"
										small
										color="error"
										@click="removeFacility(facility)"
										>x</v-btn
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="col-md-12" v-if="chosenExternalFacilities.length > 0">
					<h4 class="earth-color">NEW OL PEJETA ESCAPES BOOKINGS</h4>
					<v-flex lg12 md12 sm12 xs12>
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>Dates</th>
									<th>Accomodation</th>
									<th>Parameter Name</th>
									<th>Value</th>
									<th>Discount</th>
									<th>Supplement Price</th>
									<th>Total Amount</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(facility, key) in chosenExternalFacilities"
									:key="key"
								>
									<td>
										{{ facility.start_date }} -
										{{ facility.end_date }}
									</td>
									<td>{{ facility.name }}</td>
									<td>
										{{ facility.facility_parameter_name }}

										<p
											class="m-0 grey--text"
											v-for="(supPrice, key) in facility.non_priced_parameter"
											:key="key"
										>
											{{ supPrice.facility_parameter_name }}:{{
												supPrice.parameter_default_value
											}}
										</p>
									</td>

									<td v-if="facility.facility_pricing_point == 1">
										{{ facility.parameter_default_value }}<b> @ </b
										>{{ currency }}
										{{
											$roundOff(
												convert1(
													facility.prices.currency_type,
													facility.prices.mandatory_price
												).amount
											)
										}}<b> For </b>
										{{ getDays(facility.start_date, facility.end_date) }} Night
									</td>

									<td v-else>
										{{ facility.parameter_default_value }}
									</td>
									<td>{{ facility.accommodation_discount }}%</td>

									<td>
										<p
											v-for="(supPrice, key) in facility.supplement_price"
											:key="key"
										>
											<span v-if="supPrice.is_include == true">
												{{ supPrice.facility_extra_pricing_name
												}}<span class="grey--text"
													>({{ currency }}
													{{
														$roundOff(
															convert1(supPrice.currency_type, supPrice.amount)
																.amount
														)
													}}
													x {{ facility.parameter_default_value }} x
													{{
														getDays(facility.start_date, facility.end_date)
													}}
													Nights)</span
												>
											</span>
											<!-- <span v-else>
												None
											</span> -->
										</p>
									</td>
									<td>
										<b>
											{{ $localCurrency }}
											{{
												$roundOff(
													getDays(facility.start_date, facility.end_date) *
														(facility.parameter_default_value *
															((100 - facility.accommodation_discount) / 100) *
															convert1(
																facility.prices.currency_type,
																facility.prices.mandatory_price
															).amount +
															facility.parameter_default_value *
																convert1(
																	facility.supplement_sum.currency_type,
																	facility.supplement_sum.amount
																).amount)
												)
											}}
										</b>
									</td>
									<td>
										<v-btn
											:depressed="true"
											small
											color="error"
											@click="removeConfirmedExternalFacility(facility)"
											>x</v-btn
										>
									</td>
								</tr>
							</tbody>
						</table>
					</v-flex>
				</div>
				<div class="col-md-12" v-if="bookedFacilities.length > 0">
					<h4 class="earth-color">ALREADY BOOKED</h4>
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Accommodation</th>
								<th>Type</th>
								<th>Dates</th>
								<th>Children</th>
								<th>Adults</th>
								<th>Total Amount</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(facility, key) in bookedFacilities"
								:key="key"
								@click="rowIndex_(x)"
							>
								<td>{{ facility.facility_name }}</td>
								<td>{{ facility.facility_type }}</td>
								<td>
									{{ formated_date(facility.facility_booking_check_in_date) }} -
									{{ formated_date(facility.facility_booking_check_out_date) }}
								</td>
								<td>{{ facility.facility_booking_children }}</td>
								<td>{{ facility.facility_booking_adults }}</td>
								<td>
									{{ facility.facility_booking_currency }}
									{{ $roundOff(facility.facility_booking_total_cost) }}
								</td>

								<td v-if="route === 'PostponeBooking'">
									<v-dialog
										v-model="booking_update_dialog"
										persistent
										max-width="600px"
									>
										<v-btn
											:depressed="true"
											color="#800080"
											class="white--text"
											small
											slot="activator"
											@click="openBookingEditDialog(facility)"
										>
											postpone
										</v-btn>
										<v-card>
											<v-card-title>
												<span class="headline">
													<h4 class="earth-color">BOOKING DETAILS</h4>
												</span>
											</v-card-title>
											<v-card-text>
												<v-container grid-list-md>
													<v-layout wrap>
														<v-flex xs12 sm12 md12>
															<v-text-field
																label="Accommodation"
																required
																v-model="updated.facility_name"
																disabled
															></v-text-field>
														</v-flex>
														<v-flex
															xs12
															sm12
															md12
															v-if="updated.accomodation_type === 'Pelican'"
														>
															<v-text-field
																label="Catering Type"
																v-model="updated.facility_catering_type_name"
																required
																disabled
															></v-text-field>
														</v-flex>

														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog1"
																v-model="booking_update_dialog1"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_in_date
																		"
																		label="Check In Date"
																		hint="YYYY/MM/DD"
																		persistent-hint
																	></v-text-field>
																</template>
																<v-date-picker
																	color="primary"
																	v-model="
																		updated.facility_booking_check_in_date
																	"
																	no-title
																	@input="
																		(booking_update_dialog1 = false),
																			endDate(
																				facility.facility_booking_public_id
																			)
																	"
																></v-date-picker>
															</v-menu>
														</v-flex>

														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog2"
																v-model="booking_update_dialog2"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_out_date
																		"
																		label="Check Out Date"
																		hint="YYYY/MM/DD"
																		:disabled="true"
																		persistent-hint
																	></v-text-field>
																</template>
															</v-menu>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Children"
																type="number"
																v-model="updated.facility_booking_children"
																required
																disabled
															></v-text-field>
														</v-flex>

														<v-flex xs6>
															<v-text-field
																label="Extra Children"
																type="number"
																v-model="
																	updated.facility_booking_extra_children
																"
																required
																disabled
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Adults"
																type="number"
																v-model="updated.facility_booking_adults"
																required
																disabled
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Extra Adults"
																type="number"
																v-model="updated.facility_booking_extra_adults"
																required
																disabled
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Extra Adults"
																type="number"
																v-model="
																	updated.facility_booking_discount_percentage
																"
																required
																disabled
															></v-text-field>
														</v-flex>
													</v-layout>
												</v-container>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn
													color="red darken-1"
													flat
													@click="booking_update_dialog = false"
													>Close</v-btn
												>
												<v-btn
													color="green darken-1"
													flat
													@click="postponeFacility()"
													>Postpone</v-btn
												>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</td>
								<td v-else>
									<v-dialog
										v-model="booking_update_dialog"
										persistent
										max-width="600px"
									>
										<v-btn
											:depressed="true"
											color="warning"
											small
											slot="activator"
											@click="openBookingEditDialog(facility)"
											v-if="facility.facility_type === 'Camping Sites'"
										>
											<v-icon>edit</v-icon>
										</v-btn>

										<v-card>
											<v-card-title>
												<span class="headline">
													<h4 class="earth-color">BOOKING DETAILS</h4>
												</span>
											</v-card-title>
											<v-card-text>
												<v-container grid-list-md>
													<v-layout wrap>
														<v-flex xs12 sm12 md12>
															<v-text-field
																label="Accommodation"
																required
																v-model="updated.facility_name"
																disabled
															></v-text-field>
														</v-flex>
														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog1"
																v-model="booking_update_dialog1"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_in_date
																		"
																		label="Date"
																		hint="YYYY/MM/DD"
																		persistent-hint
																	></v-text-field>
																</template>
																<v-date-picker
																	color="primary"
																	v-model="
																		updated.facility_booking_check_in_date
																	"
																	no-title
																	@input="booking_update_dialog1 = false"
																></v-date-picker>
															</v-menu>
														</v-flex>
														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog2"
																v-model="booking_update_dialog2"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_out_date
																		"
																		label="Date"
																		hint="YYYY/MM/DD"
																		persistent-hint
																	></v-text-field>
																</template>
																<v-date-picker
																	color="primary"
																	v-model="
																		updated.facility_booking_check_out_date
																	"
																	no-title
																	@input="booking_update_dialog2 = false"
																></v-date-picker>
															</v-menu>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Children"
																type="number"
																v-model="updated.facility_booking_children"
																required
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Extra Children"
																type="number"
																v-model="
																	updated.facility_booking_extra_children
																"
																required
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Adults"
																type="number"
																v-model="updated.facility_booking_adults"
																required
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Extra Adults"
																type="number"
																v-model="updated.facility_booking_extra_adults"
																required
															></v-text-field>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Extra Adults"
																type="number"
																v-model="
																	updated.facility_booking_discount_percentage
																"
																required
															></v-text-field>
														</v-flex>
													</v-layout>
												</v-container>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn
													color="red darken-1"
													flat
													@click="booking_update_dialog = false"
													>Close</v-btn
												>
												<v-btn color="green darken-1" flat @click="saveUpdate()"
													>Update</v-btn
												>
											</v-card-actions>
										</v-card>
									</v-dialog>
									<v-btn
										:depressed="true"
										small
										color="error"
										@click="removeBookedFacility(facility)"
										>x</v-btn
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="col-md-12" v-if="finExternalFacilities.length > 0">
					<h4 class="earth-color">ALREADY BOOKED OL PEJETA ESCAPES</h4>
					<table class="table table-bordered">
						 <thead>
							<tr>
								<th>Accommodation</th>
								<th>Price Parameter</th>
								<th>Dates</th>
								<th>Total Amount</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(facility, key) in finExternalFacilities"
								:key="key"
							>
								<td>{{ facility.facility_name }}</td>
								
							
								<td><b>{{facility.pricing_parameter.parameter_default_value}}  </b> {{facility.pricing_parameter.parameter_name}}</td>
								 <td>
									{{ formated_date(facility.facility_booking_check_in_date) }} -
									{{ formated_date(facility.facility_booking_check_out_date) }}
								</td>
								 <td>
									 {{ $localCurrency }}
													{{
													$roundOff(
														convert1(
														facility.facility_booking_currency,
														facility.facility_booking_total_cost
														).amount)
													}}
										</td>
						<!-- for postponing external facility -->
						 <td v-if="route === 'PostponeBooking'">
									<v-dialog
										v-model="booking_external_update_dialog"
										persistent
										max-width="600px"
									>
										<v-btn
											:depressed="true"
											color="#800080"
											class="white--text"
											small
											slot="activator"
											@click="openExternalBookingEditDialog(facility)"
										>
											postpone
										</v-btn>
										<v-card>
											<v-card-title>
												<span class="headline">
													<h4 class="earth-color">BOOKING DETAILS</h4>
												</span>
											</v-card-title>
											<v-card-text>
												<v-container grid-list-md>
													<v-layout wrap>
														<v-flex xs12 sm12 md12>
															<v-text-field
																label="Accommodation"
																required
																v-model="updated.facility_name"
																disabled
															></v-text-field>
														</v-flex>
														
														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog4"
																v-model="booking_update_dialog4"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_in_date
																		"
																		label="Check In Date"
																		hint="YYYY/MM/DD"
																		persistent-hint
																	></v-text-field>
																</template>
																<v-date-picker
																	color="primary"
																	v-model="
																		updated.facility_booking_check_in_date
																	"
																	no-title
																	@input="
																		(booking_update_dialog4 = false),
																			endExternalFacilityDate(
																				facility.facility_booking_public_id
																			)
																	"
																></v-date-picker>
															</v-menu>
														</v-flex>

														<v-flex xs12 sm12 md6>
															<v-menu
																ref="booking_update_dialog5"
																v-model="booking_update_dialog5"
																:close-on-content-click="false"
																:nudge-right="40"
																lazy
																transition="scale-transition"
																offset-y
																full-width
																max-width="290px"
																min-width="290px"
															>
																<template slot="activator">
																	<v-text-field
																		v-model="
																			updated.facility_booking_check_out_date
																		"
																		label="Check Out Date"
																		hint="YYYY/MM/DD"
																		:disabled="true"
																		persistent-hint
																	></v-text-field>
																</template>
															</v-menu>
														</v-flex>
														<v-flex xs6>
															<v-text-field
																label="Default Value"
																type="number"
																v-model="updated.parameter_default_value"
																required
																disabled
															></v-text-field>
														</v-flex>

														<v-flex xs6>
															<v-text-field
																label="Parameter Name"
															 
																v-model="
																	updated.parameter_name
																"
																required
																disabled
															></v-text-field>
														</v-flex>
													 
													</v-layout>
												</v-container>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn
													color="red darken-1"
													flat
													@click="booking_external_update_dialog = false"
													>Close</v-btn
												>
												<v-btn
													color="green darken-1"
													flat
													@click="postponeExternalFacility()"
													>Postpone</v-btn
												>
											</v-card-actions>
										</v-card> 
									</v-dialog>
								</td>

								<td v-else> 
									<v-btn
										:depressed="true"
										@click="removeAlreadyBookedExternalFacility(facility)"
										small
										color="error"
										>x</v-btn
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</v-container>
		</v-container>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
	components: { Datepicker },
	name: "facility-booking",
	data() {
		return {
			limitRules: [v => v < 101 || "Discount cannot be more than 100%"],
			today: this.$moment().format("YYYY-MM-DD"),
			backdate_today: this.$moment()
				.subtract(7, "d")
				.format("YYYY-MM-DD"),
			requiredRules: [v => !!v || "This field is required"],
			menu1: false,
			modal1: false,
			modal11: false,
			menu2: false,
			modal2: false,
			 modal12: false,
			modal3: false,
			dialog: false,
			dialog1: false,
			dialog2: false,
			
			dialog11: false,
			dialog12: false,
			dialog13: false,
			enddialog2: false,
			booking_update_dialog: false,
			booking_external_update_dialog: false,
			booking_update_dialog1: false,
			booking_update_dialog2: false,
			booking_update_dialog3: false,
			booking_update_dialog4: false,
			booking_update_dialog5: false,

			notifications: false,
			sound: true,
			widgets: false,
			route: this.$route.name,
			is_camping: false,
			bookedFacilities_: JSON.parse(localStorage.getItem("old_facility_data")),
			facility: {
				catering_type: "",
				accommodation: {},
				start_date: "",
				end_date: "",
				accommodation_discount: 0,
				children: 0,
				adults: 0,
				extra_pax_adults: 0,
				extra_pax_children: 0,
				has_extras: false,
				multi: [],
				number_of_rooms: 0,
				external_facility_status: false
			},
			multi: {
				start_date: "",
				end_date: "",
				adults: 0,
				children: 0,
				discount: 0,
				expected_to_pay: true
			},
			external_facility: {
				start_date: "",
				end_date: "",
				accommodation: {},
				children: 0,
				discount: 0,
				expected_to_pay: true,
				value: 0,
				external_array: []
			},
			updated: {
				facility_name: "",
				facility_type: "",
				accomodation_type: "",
				facility_catering_type_name: "",
				facility_id: "",
				facility_booking_id: "",
				facility_booking_public_id: "",
				facility_booking_check_in_date: "",
				facility_booking_check_out_date: "",
				facility_booking_guests: 0,
				facility_booking_adults: 0,
				facility_booking_children: 0,
				facility_booking_extra_adults: 0,
				facility_booking_extra_children: 0,
				facility_booking_discount_percentage: 0,
				facility_booking_commission_percentage: 0,
				facility_booking_currency: "",
				facility_no_of_nights: 0,
				unit: "",
				facility_booking_fixed_cost: 0,
				facility_booking_fixed_cost_before_discount: 0,
				facility_booking_adult_cost: 0,
				facility_booking_cost_per_adult: 0,
				facility_booking_adult_cost_before_discount: 0,
				facility_booking_child_cost: 0,
				facility_booking_cost_per_child: 0,
				facility_booking_child_cost_before_discount: 0,
				facility_booking_discount: 0,
				facility_booking_special_discount: 0,
				facility_booking_total_cost: 0,
				facility_booking_total_cost_before_discount: 0,
				no_of_rooms: 0,
				facility_parameter_name: ""
			},
			updated_bookings: [],
			_rowIndex: 0,
			availability: "",
			external_facility_arr: []
		};
	},
	computed: {
		childSlots() {
			var slots = [];
			var available = this.calculateChildMax;
			for (var i = 0; i <= available; i++) {
				slots.push(i);
			}
			return slots;
		},
		adultSlots() {
			var slots = [];
			var available = this.calculateAdultMax;
			for (var i = 0; i <= available; i++) {
				slots.push(i);
			}
			return slots;
		},
		roomSlots() {
			var slots = [];
			var available = this.facility.accommodation.quantity;
			for (var i = 0; i <= available; i++) {
				slots.push(i);
			}
			return slots;
		},
		facilityAvailablity: function() {
			return this.$store.state.BookingStore.single_facility;
		},
		cateringType() {
			var normalPricing = [];
			var leadTime = parseInt(this.facility.accommodation.price[0].lead_time);
			var today = new Date();
			var current_d = today.setDate(today.getDate() + leadTime);
			var current_day = new Date(current_d);
			var check_in_date = new Date(this.facility.start_date);

			var length = this.$allPricingGroups.length;
			for (var i = 0; i < length; i++) {
				if (i < 3) {
					if (check_in_date < current_day) {
						let fac_name = this.$allPricingGroups[i].facility_pricing_name;
						if (fac_name == "Fully Catered") {
						} else {
							normalPricing.push(this.$allPricingGroups[i]);
						}
					} else {
						normalPricing.push(this.$allPricingGroups[i]);
					}
				}
			}
			var route = this.$route.name;
			if (route === "NewBooking" || route === "EditBooking") {
				return this.$allPricingGroups;
			} else {
				return normalPricing;
			}
		},

		currency: function() {
			return this.$store.state.CurrencyStore.browser_currency;
		},
		facilitySlots: function() {
			var slots =
				Number(
					this.singleFacility.maximum_guests *
						Number(this.facility.accommodation.quantity)
				) - Number(this.total);
			if (isNaN(slots) === true) {
				return 0;
			} else {
				return slots;
			}
		},
		AvailablefacilitySlots: function() {
			var slots = Number(
				this.singleFacility.maximum_guests *
					Number(this.facility.accommodation.quantity)
			);
			if (isNaN(slots) === true) {
				return 0;
			} else {
				return slots;
			}
		},
		calculateAdultMax: function() {
			return (
				Number(
					this.facility.accommodation.maximum_guests *
						Number(this.facility.accommodation.quantity)
				) -
				Number(this.total) +
				this.facility.adults
			);
		},
		calculateChildMax: function() {
			return (
				Number(
					this.facility.accommodation.maximum_guests *
						Number(this.facility.accommodation.quantity)
				) -
				Number(this.total) +
				this.facility.children
			);
		},
		total: function() {
			return Number(this.facility.adults) + Number(this.facility.children);
		},
		disabled_settings: function() {
			var startDate = this.$moment().format("YYYY-MM-DD");
			return {
				to: new Date(this.$moment(startDate).format("YYYY, MM, DD"))
			};
		},
		externalFacilityPricing: function() {
			if (
				this.$route.name === "NewBooking" ||
				this.$route.name === "EditBooking"
			) {
				return this.$store.state.FacilityStore.single_external_facilty_price;
			} else if (this.$route.name === "PostponeBooking") {
				this.$store.commit(
					"UPDATE_SINGLE_EXTERNAL_FACILITY_PRICE",
					this.$store.state.FacilityStore.single_external_facilty_price
				);
				return this.$store.state.FacilityStore.single_external_facilty_price;
			} else {
				return this.$store.state.FacilityStore.single_external_facilty_price;
			}
		},
		accommodationTotal: function() {
			var externalFacilityTotal = this.externalFacilityPricing;
			if (externalFacilityTotal.length > 0 ){
			var size = externalFacilityTotal.length;

			var total = 0;
		 
			for (var i = 0; i < size; i++) {
				// if(externalFacilityTotal[i].allocation_name[0])
				total =
					total +
					Math.ceil(
						this.convert1(
							externalFacilityTotal[i].prices.currency_type,
							externalFacilityTotal[i].prices.mandatory_price
						).amount *
							Number(externalFacilityTotal[i].parameter_default_value) *
							((100 - externalFacilityTotal[i].accommodation_discount) / 100) +
							Number(externalFacilityTotal[i].parameter_default_value) *
								this.convert1(
									externalFacilityTotal[i].supplement_sum.currency_type,
									externalFacilityTotal[i].supplement_sum.amount
								).amount
					);
			}

			switch (this.$route.name) {
				case "Reservation":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
				case "PaymentInformation":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
				case "NewBooking":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
				case "NewPartnerBooking":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
				case "EditBooking":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
				case "PostponeBooking":
					total =
						total *
						this.getDays(
							this.external_facility.start_date,
							this.external_facility.end_date
						);
					break;
			}

			return total;
		}else{
			return 0
		}

			}
		 
	},
	methods: {
		setSwitchesForItem: function(supplementPrice) {
			let externalFacilityPricing = this.externalFacilityPricing;
			let facilityPriceArr = externalFacilityPricing.filter(
				externalFacilityPrice =>
					externalFacilityPrice.public_id === supplementPrice.parameter_id
			);
			let allSupplementPrices = facilityPriceArr[0].supplement_price;

			for (let i = 0; i < allSupplementPrices.length; i++) {
				if (supplementPrice.public_id == allSupplementPrices[i].public_id) {
					allSupplementPrices[i].is_include = supplementPrice.is_include;
				}
			}

			let priceArr = [];
			for (let j = 0; j < allSupplementPrices.length; j++) {
				if (allSupplementPrices[j].is_include == true) {
					let amount = this.convert1(
						allSupplementPrices[j].currency_type,
						allSupplementPrices[j].amount
					).amount;
					priceArr.push(parseFloat(amount));
				}
			}

			var sumPrice = priceArr.reduce(function(a, b) {
				return a + b;
			}, 0);

			facilityPriceArr[0].supplement_sum = {
				currency_type: this.$store.state.CurrencyStore.browser_currency,
				amount: sumPrice
			};
		},
		searchFacilityAvailability: function() {
			var data = {
				check_in_date: this.facility.start_date,
				check_out_date: this.facility.end_date
			};
			this.$store.commit("REMOVE_AVAILABLE_FACILITIES");
			this.facility.accommodation = {}
			if (
				this.$route.name === "Reservation" ||
				this.$route.name === "NewPartnerBooking"
			) {
				this.$store.dispatch("check_date_facility_public_availability", data);
			} else {
				this.enddialog2 = false;
				this.$store.dispatch("check_date_facility_availability", data);
			}
		},
		resetForAvailability: function() {
			this.facility.end_date = ""
			// this.facility.accommodation.accomodation_type_id === ''
			this.facility.accommodation = {}
			this.$store.commit("REMOVE_AVAILABLE_FACILITIES");
		},
	 
		searchExternalFacilityAvailability: function() {
			var data = {
				check_in_date: this.external_facility.start_date,
				check_out_date: this.external_facility.end_date
			};

			if (
				this.$route.name === "Reservation" ||
				this.$route.name === "NewPartnerBooking"
			) {
				this.$store.dispatch(
					"check_date_external_facility_public_availability",
					data
				);
			} else {
				this.enddialog2 = false;
				this.$store.dispatch("check_date_external_facility_availability", data);
			}
		},
		searchSingleAvailability: function(data) {
			this.$store.dispatch("check_date_single_facility_availability", data);
			this.facilityAvailability();
		},
		facilityAvailability: function() {
			let availableData = this.$store.state.BookingStore.single_facility;

			this.availability = availableData;
		},
		endDate(data) {
			let instance = this;

			let oldFacilityData = JSON.parse(
				localStorage.getItem("old_facility_data")
			);

			let postponeFacility = oldFacilityData.filter(
				facilityData => facilityData.facility_booking_public_id === data
			);
			let facilityStartDate =
				postponeFacility[0].facility_booking_check_in_date;

			let facilityEndDate = postponeFacility[0].facility_booking_check_out_date;
			const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
			const firstDate = new Date(facilityStartDate);
			const secondDate = new Date(facilityEndDate);
			const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

			let postponedCheckInDate = new Date(
				instance.updated.facility_booking_check_in_date
			);
			postponeFacility[0]["facility_booking_check_in_date"] =
				instance.updated.facility_booking_check_in_date;

			let postponedCheckOutDate = postponedCheckInDate.setDate(
				postponedCheckInDate.getDate() + diffDays
			);
			let postponedCheckOutDateFormatted = new Date(postponedCheckOutDate);
			instance.updated.facility_booking_check_out_date = this.$moment(
				postponedCheckOutDate
			).format("YYYY-MM-DD");

			postponeFacility[0]["facility_booking_check_out_date"] = this.$moment(
				postponedCheckOutDateFormatted
			).format("YYYY-MM-DD");

			this.searchSingleAvailability(postponeFacility[0]);
		},
		endExternalFacilityDate(data) {
			let instance = this;

			let oldFacilityData = JSON.parse(
				localStorage.getItem("old_external_facility_data")
			);

			let postponeFacility = oldFacilityData.filter(
				facilityData => facilityData.facility_booking_public_id === data
			);
			let facilityStartDate =
				postponeFacility[0].facility_booking_check_in_date;

			let facilityEndDate = postponeFacility[0].facility_booking_check_out_date;
			const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
			const firstDate = new Date(facilityStartDate);
			const secondDate = new Date(facilityEndDate);
			const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

			let postponedCheckInDate = new Date(
				instance.updated.facility_booking_check_in_date
			);
			postponeFacility[0]["facility_booking_check_in_date"] =
				instance.updated.facility_booking_check_in_date;

			let postponedCheckOutDate = postponedCheckInDate.setDate(
				postponedCheckInDate.getDate() + diffDays
			);
			let postponedCheckOutDateFormatted = new Date(postponedCheckOutDate);
			instance.updated.facility_booking_check_out_date = this.$moment(
				postponedCheckOutDate
			).format("YYYY-MM-DD");

			postponeFacility[0]["facility_booking_check_out_date"] = this.$moment(
				postponedCheckOutDateFormatted
			).format("YYYY-MM-DD");

			// this.searchSingleAvailability(postponeFacility[0]);
		},
		getFacility: function(facility) {
			this.facility.accommodation = facility;
			if (
				this.facility.accommodation.facility_type_id.toLowerCase() ===
				"camping sites"
			) {
				this.is_camping = true;
				this.multi.start_date = this.facility.start_date;
				this.multi.end_date = this.facility.end_date;
			} else {
				this.is_camping = false;
			}
			var postData = {
				public_id: facility.public_id,
				start_date: this.facility.start_date,
				end_date: this.facility.end_date
			};
	
			this.$store.dispatch("get_facility_with_pricing", postData);
		},
		getExternalFacility: function(facility) {
			this.$store.commit("SINGLE_EXTERNAL_FACILITY_PRICE", []);
		 
			this.external_facility.accommodation = facility;
			if (facility.pricing_parameter_set) {
				this.$store.commit("SINGLE_EXTERNAL_FACILITY_PRICE", facility.price);
			} else {
				this.$store.commit("SINGLE_EXTERNAL_FACILITY_PRICE", []);
			}
		},
		putStartDate: function() {
			var date = this.$moment(this.facility.start_date).format("YYYY-MM-DD");
			this.facility.start_date = date;
		},
		putEndtDate: function() {
			var date = this.$moment(this.facility.end_date).format("YYYY-MM-DD");
			this.facility.end_date = date;
		},
		findGroup(facility) {
			var Groups = facility.group_price;
			var cateringGroup = this.facility.catering_type;
			return Groups.map(function(group) {
				if (group.group === cateringGroup) {
					return Groups.indexOf(group);
				}
			});
		},
		addCampingArrival() {
			let facility = this.facility.accommodation;
			var data = {
				public_id: facility.public_id,
				catering_type: facility.catering_type,
				facility_type: facility.facility_type_id,
				accommodation_type: facility.accomodation_type_id,
				name: facility.name,
				start_date: this.multi.start_date,
				end_date: this.multi.end_date,
				adults: this.multi.adults,
				children: this.multi.children,
				discount: this.multi.discount,
				expected_to_pay: this.multi.expected_to_pay,
				adult_price: facility.price[0].adult_price,
				child_price: facility.price[0].child_price,
				mandatory_price: facility.price[0].mandatory_price,
				currency: facility.price[0].currency_type
			};
			this.facility.multi.push(data);
			var oldData = JSON.parse(localStorage.getItem("camping_multi_data"));
			this.$store.commit("CAMPING_MULTI_DATA", oldData);
			this.$store.commit("ADD_CAMPING_MULTI", data);
			localStorage.setItem(
				"camping_multi_data",
				JSON.stringify(this.addedMultiArrivals)
			);

			this.multi.start_date = this.facility.start_date;
			this.multi.end_date = this.facility.end_date;
			this.multi.adults = 0;
			this.multi.children = 0;
			this.multi.discount = 0;
			this.multi.expected_to_pay = true;
		},
		confirmArrivals() {
			let facility = this.facility.accommodation;
			let data = {
				public_id: facility.public_id,
				catering_type: this.facility.catering_type,
				facility_type: facility.facility_type_id,
				accommodation_type: facility.accomodation_type_id,
				start_date: this.facility.start_date,
				end_date: this.facility.end_date,
				name: facility.name,
				extra_pax_adults: Number(this.facility.extra_pax_adults),
				extra_pax_children: Number(this.facility.extra_pax_children),
				accommodation_discount: Number(this.facility.accommodation_discount),
				discounts: facility.discount,
				discount_status: facility.discount_status,
				is_multi: true,
				mandatory_price: facility.price[0].mandatory_price,
				currency: facility.price[0].currency_type
			};
			
			if (this.addedMultiArrivals.length > 0) {
				let totalAdults = 0;
				let totalChildren = 0;
				let totalCost = 0;
				for (
					let arrival = 0;
					arrival < this.addedMultiArrivals.length;
					arrival++
				) {
					totalAdults =
						Number(totalAdults) +
						Number(this.addedMultiArrivals[arrival].adults);
					totalChildren =
						Number(totalChildren) +
						Number(this.addedMultiArrivals[arrival].children);
					totalCost =
						totalCost +
						this.multiArrivalsTotal(this.addedMultiArrivals[arrival]);
				}
				var newData = {
					adults: totalAdults,
					children: totalChildren,
					multiTotal: totalCost
				};
				Object.assign(data, newData);
				// var oldData = JSON.parse(localStorage.getItem('facility_data'))
				// this.$store.commit('BROWSER_FACILITIES', oldData)
				this.$store.commit("ADD_FACILITY", data);
				localStorage.setItem(
					"facility_data",
					JSON.stringify(this.chosenFacilities)
				);
				this.dialog = false;
			}
		},
		addAccommodation: function() {
			let adultsCount = [];
			let childrenCount = [];
			let instancesOfAccommodation = 0;
			let alreadySelected = false;
			let selectedName;

			for (let eachFacility of this.chosenFacilities) {
				if (eachFacility.public_id === this.facility.accommodation.public_id) {
					if (
						this.facility.accommodation.public_id ==
						"9221ced6-4704-4a9c-a327-d5771f3434d8"
					) {
						adultsCount.push(eachFacility.number_of_rooms);
						childrenCount.push(0);
						instancesOfAccommodation++;
					} else if (
						this.facility.accommodation.public_id ==
						"35b57e2b-ee6c-4c84-8bb3-183f3c8b92a2"
					) {
						adultsCount.push(eachFacility.number_of_rooms);
						childrenCount.push(0);
						instancesOfAccommodation++;
					} else {
						adultsCount.push(eachFacility.adults);
						childrenCount.push(eachFacility.children);
						instancesOfAccommodation++;
					}
				}
			}
			let guestTotal;
			let accQuantity;
			let accMaxGuests;
			let bookedGuests;
			let visitsTotal;
			let accMax;
			let accName;
			if (
				this.facility.accommodation.public_id ==
				"9221ced6-4704-4a9c-a327-d5771f3434d8"
			) {
				visitsTotal =
					Number(this.facility.children) + Number(this.facility.adults);

				guestTotal =
					adultsCount.reduce((a, b) => a + b, 0) +
					childrenCount.reduce((a, b) => a + b, 0);
				accQuantity = Number(this.facility.accommodation.quantity);
				accMax = Number(this.facility.accommodation.maximum_guests);
				accName = this.facility.accommodation.name;
				accMaxGuests = 1;
				bookedGuests = this.facility.number_of_rooms;
				// let accMaxWord = this.inWords(accMax);
				if (bookedGuests <= 0) {
					alert("Enter number of rooms needed");
					return;
				}
				if (bookedGuests == 1 && visitsTotal > accMax) {
					alert("One room can have a maximum of " + accMax + " people");
					return;
				}
			} else if (
				this.facility.accommodation.public_id ==
				"35b57e2b-ee6c-4c84-8bb3-183f3c8b92a2"
			) {
				visitsTotal =
					Number(this.facility.children) + Number(this.facility.adults);
				guestTotal =
					adultsCount.reduce((a, b) => a + b, 0) +
					childrenCount.reduce((a, b) => a + b, 0);
				accQuantity = Number(this.facility.accommodation.quantity);
				accMax = Number(this.facility.accommodation.maximum_guests);
				accName = this.facility.accommodation.name;
				accMaxGuests = 1;
				bookedGuests = this.facility.number_of_rooms;

				if (bookedGuests <= 0) {
					alert("Enter number of rooms needed");
					return;
				}
				if (bookedGuests == 1 && visitsTotal > accMax) {
					alert("One room can have a maximum of " + accMax + " people");
					return;
				}
			} else {
				guestTotal =
					adultsCount.reduce((a, b) => a + b, 0) +
					childrenCount.reduce((a, b) => a + b, 0);
				accQuantity = Number(this.facility.accommodation.quantity);
				accMaxGuests = Number(this.facility.accommodation.maximum_guests);
				bookedGuests = this.facility.adults + this.facility.children;
			}

			if (accQuantity === 1) {
				if (instancesOfAccommodation >= 1) {
					alreadySelected = true;
					selectedName = this.facility.accommodation.name;
				}
			} else if (accQuantity > 1) {
				if (guestTotal + bookedGuests > accMaxGuests * accQuantity) {
					alreadySelected = true;
					selectedName = this.facility.accommodation.name;
				}
			}
			if (alreadySelected) {
				alert(
					selectedName +
						" already selected and cannot go beyond the maximum quantity."
				);
				return;
			}
			let facility = this.facility.accommodation;

			// let bookingPartnerName =this.$store.state.BookingStore.booking_partner_name

			if (facility.pricing_status === "false") {
				alert("No pricing has been set for this period");
			} else if (
				facility.accomodation_type_id === "Pelican" &&
				this.facility.catering_type !== "9a9a77eb" &&
				this.facility.catering_type !== "266677c3" &&
				facility.group_pricing_status === "false"
			) {
				alert("No special Pricing available for the selected Accommodation");
			} else {
				let data = {
					public_id: facility.public_id,
					catering_type: this.facility.catering_type,
					facility_type: facility.facility_type_id,
					accommodation_type: facility.accomodation_type_id,
					start_date: this.facility.start_date,
					end_date: this.facility.end_date,
					name: facility.name,
					children: this.facility.children,
					adults: this.facility.adults,
					extra_pax_adults: Number(this.facility.extra_pax_adults),
					extra_pax_children: Number(this.facility.extra_pax_children),
					accommodation_discount: Number(this.facility.accommodation_discount),
					discounts: facility.discount,
					discount_status: facility.discount_status,
					number_of_rooms: this.facility.number_of_rooms
				};
				if (facility.accomodation_type_id === "Pelican") {
					let priceIndex;
					let currencyList = [];
					// Self-Catered
					if (this.facility.catering_type === "9a9a77eb") {
						// Self Catered
						facility.price.map(function(item, index) {
							if (
								item.hasOwnProperty("lower_limit_list") &&
								item.lower_limit_list.length > 0
							) {
								priceIndex = index;
								currencyList = item.upper_currency;
							}
						});
					} else if (this.facility.catering_type === "266677c3") {
						// 266677c3 => Self-Catered
						// Fully Catered
						facility.price.map(function(item, index) {
							if (
								item.hasOwnProperty("upper_upper_limit_list") &&
								item.upper_upper_limit_list.length > 0
							) {
								priceIndex = index;
								currencyList = item.lower_currency;
							}
						});
					} else if (this.facility.catering_type === "377788d4") {
						// Self-Catered + Chef
						facility.price.map(function(item, index) {
							if (
								item.hasOwnProperty("middle_middle_limit_list") &&
								item.middle_middle_limit_list.length > 0
							) {
								priceIndex = index;
								currencyList = item.upper_currency;
							}
						});
					}
					var pelicanPricing = {
						pack_prices: facility.price[priceIndex],
						pack_currency: facility.price[priceIndex],
						pelican_lower_currency: currencyList
					};
					Object.assign(data, pelicanPricing);
				} else if (facility.accomodation_type_id === "Stables") {
					switch (Number(facility.maximum_guests)) {
						case 1:
							// Single Room
							var SingleRoomPricing = {
								quantity: facility.quantity,
								maximum_guests: facility.maximum_guests,
								child_price: facility.price[0].child_price,
								mandatory_price: facility.price[0].mandatory_price,
								currency: facility.price[0].currency_type,
								adult_price:
									facility.price[0].mandatory_price * this.facility.adults
							};

							Object.assign(data, SingleRoomPricing);
							break;
						case 2:
							var doubleTwinPricing = {
								adult_price: facility.price[0].adult_price,
								child_price: facility.price[0].child_price,
								mandatory_price: facility.price[0].mandatory_price,
								currency: facility.price[0].currency_type,
								maximum_guests: facility.maximum_guests
							};

							Object.assign(data, doubleTwinPricing);
							break;
						default:
							var _nonPelicanPricing = {
								adult_price: facility.price[0].adult_price,
								child_price: facility.price[0].child_price,
								mandatory_price: facility.price[0].mandatory_price,
								currency: facility.price[0].currency_type,
								maximum_guests: facility.maximum_guests
							};

							Object.assign(data, _nonPelicanPricing);
					}
				} else {
					// Camping
					var nonPelicanPricing = {
						adult_price: facility.price[0].adult_price,
						child_price: facility.price[0].child_price,
						mandatory_price: facility.price[0].mandatory_price,
						currency: facility.price[0].currency_type
					};
					Object.assign(data, nonPelicanPricing);
				}
				if (
					facility.group_pricing_status === "true" &&
					this.facility.catering_type !== "9a9a77eb" &&
					this.facility.catering_type !== "266677c3" &&
					this.facility.catering_type !== "377788d4"
				) {
					var extraData = {
						extra_price:
							facility.group_price[this.findGroup(facility)].extra_price,
						special_mandatory_price:
							facility.group_price[this.findGroup(facility)].mandatory_price,
						special_currency:
							facility.group_price[this.findGroup(facility)].currency_type,
						from_number:
							facility.group_price[this.findGroup(facility)].from_number,
						to_number: facility.group_price[this.findGroup(facility)].to_number,
						maximum_number:
							facility.group_price[this.findGroup(facility)].maximum_number
					};
					Object.assign(data, extraData);
				}
				var oldData = JSON.parse(localStorage.getItem("facility_data"));
				this.$store.commit("BROWSER_FACILITIES", oldData);
				this.$store.commit("ADD_FACILITY", data);
				localStorage.setItem(
					"facility_data",
					JSON.stringify(this.chosenFacilities)
				);
				this.facility.adults = 0;
				this.facility.children = 0;
			}
		},
		cateringTypePublic: function() {
			var normalPricing = [];
			var leadTime = parseInt(this.facility.accommodation.price[0].lead_time);
			var today = new Date();
			var current_d = today.setDate(today.getDate() + leadTime);
			var current_day = new Date(current_d);
			var check_in_date = this.facility.start_date;

			var length = this.$allPricingGroups.length;
			for (var i = 0; i < length; i++) {
				if (i < 3) {
					if (
						this.$allPricingGroups[i].facility_pricing_name ==
							"Fully Catered" &&
						check_in_date < current_day
					) {
					} else {
						normalPricing.push(this.$allPricingGroups[i]);
					}
				}
			}
			var route = this.$route.name;
			if (route === "NewBooking" || route === "EditBooking") {
				return this.$allPricingGroups;
			} else {
				return normalPricing;
			}
		},

		openBookingEditDialog: function(facility) {
			this.updated = facility;
			this.updated.facility_booking_check_in_date = this.$moment(
				facility.facility_booking_check_in_date
			).format("YYYY-MM-DD");
			this.updated.facility_booking_check_out_date = this.$moment(
				facility.facility_booking_check_out_date
			).format("YYYY-MM-DD");
			this.updated.facility_booking_id = facility.facility_booking_public_id;
		},
		openExternalBookingEditDialog: function(facility) {
			this.updated = facility;
			this.updated.facility_booking_check_in_date = this.$moment(
				facility.facility_booking_check_in_date
			).format("YYYY-MM-DD");
			this.updated.facility_booking_check_out_date = this.$moment(
				facility.facility_booking_check_out_date
			).format("YYYY-MM-DD");
			this.updated.facility_booking_id = facility.facility_booking_public_id;
			this.updated.parameter_default_value = facility.pricing_parameter.parameter_default_value;
			this.updated.parameter_name = facility.pricing_parameter.parameter_name;
		},
		rowIndex_(x) {
			this._rowIndex = x.rowIndex;
		},
		saveUpdate() {
			this.booking_update_dialog = false;
			this.updated.facility_booking_total_cost = this.updatedTotal(
				this.updated
			);
			if (this.updated_bookings.length > 0) {
				for (
					let booking = 0;
					booking < this.updated_bookings.length;
					booking++
				) {
					if (
						this.updated_bookings[booking].facility_booking_public_id ===
						this.updated.facility_booking_public_id
					) {
						this.updated_bookings[booking] === this.updated;
					} else {
						this.updated_bookings.push(this.updated);
					}
				}
			} else {
				this.updated_bookings.push(this.updated);
			}
			// Send the updated records to the backend for processing
			this.$store.dispatch("updated_campsite_booking", this.updated);
		},
		postponeFacility() {
			this.booking_update_dialog = false;
			let beforeData = [];

			// localStorage.setItem("postponed_facility_data", JSON.stringify([]));

			if (JSON.parse(localStorage.getItem("postponed_facility_data") == null)) {
				beforeData = beforeData;
			} else {
				beforeData = JSON.parse(
					localStorage.getItem("postponed_facility_data")
				);
			}

			let postponeIds = beforeData.map(before => {
				return before.facility_booking_public_id;
			});
			let postponeData = this.updated;
			let postponeBookingFacilityId = postponeData.facility_booking_public_id;
			if (postponeIds.includes(postponeBookingFacilityId)) {
				for (let i = 0; i < beforeData.length; i++) {
					let bookingFacilityId = beforeData[i].facility_booking_public_id;
					if (bookingFacilityId == postponeBookingFacilityId) {
						beforeData[i]["facility_booking_check_in_date"] =
							postponeData.facility_booking_check_in_date;
						beforeData[i]["facility_booking_check_out_date"] =
							postponeData.facility_booking_check_out_date;
						localStorage.setItem(
							"postponed_facility_data",
							JSON.stringify(beforeData)
						);
					}
				}
				localStorage.setItem(
					"postponed_facility_data",
					JSON.stringify(beforeData)
				);
			} else {
				beforeData.push(postponeData);
				localStorage.setItem(
					"postponed_facility_data",
					JSON.stringify(beforeData)
				);
			}
		},
		postponeExternalFacility() {
			this.booking_external_update_dialog = false;
			let beforeData = [];

			if (JSON.parse(localStorage.getItem("postponed_external_facility_data") == null)) {
				beforeData = beforeData;
			} else {
				beforeData = JSON.parse(
					localStorage.getItem("postponed_external_facility_data")
				);
			}

			let postponeIds = beforeData.map(before => {
				return before.facility_booking_public_id;
			});
			let postponeData = this.updated;
			let postponeBookingFacilityId = postponeData.facility_booking_public_id;
			if (postponeIds.includes(postponeBookingFacilityId)) {
				for (let i = 0; i < beforeData.length; i++) {
					let bookingFacilityId = beforeData[i].facility_booking_public_id;
					if (bookingFacilityId == postponeBookingFacilityId) {
						beforeData[i]["facility_booking_check_in_date"] =
							postponeData.facility_booking_check_in_date;
						beforeData[i]["facility_booking_check_out_date"] =
							postponeData.facility_booking_check_out_date;
						localStorage.setItem(
							"postponed_external_facility_data",
							JSON.stringify(beforeData)
						);
					}
				}
				localStorage.setItem(
					"postponed_external_facility_data",
					JSON.stringify(beforeData)
				);
			} else {
				beforeData.push(postponeData);
				localStorage.setItem(
					"postponed_external_facility_data",
					JSON.stringify(beforeData)
				);
			}
		},
		updatedTotal(accommodation) {
			var days = this.getDays(
				accommodation.facility_booking_check_in_date,
				accommodation.facility_booking_check_out_date
			);
			let total = 0;
			let discount = Number(accommodation.facility_booking_discount_percentage);
			let adultCount = Number(accommodation.facility_booking_adults);
			let extraAdults = Number(accommodation.facility_booking_extra_adults);
			let childrenCount = Number(accommodation.facility_booking_children);
			let extraChildren = Number(accommodation.facility_booking_extra_children);
			let totalGuestsCount = adultCount + childrenCount;
			if (accommodation.facility_type === "Camping Sites") {
				let adultCost =
					(adultCount + extraAdults) *
					Number(accommodation.facility_booking_cost_per_adult) *
					days;
				let childCost =
					(childrenCount + extraChildren) *
					Number(accommodation.facility_booking_cost_per_child) *
					days;
				let updatedDiscount = discount / 100;
				total = Number(
					adultCost +
						childCost +
						Number(accommodation.facility_booking_fixed_cost)
				);
				let discountTotal = total * updatedDiscount;
				total = total - discountTotal;
				return total;
			} else if (
				accommodation.facility_type.toLowerCase() === "accomodation" &&
				accommodation.accomodation_type.toLowerCase() === "stables"
			) {
				let costPerRoom = accommodation.cost_per_room;
				let costPerExtraAdult = accommodation.cost_per_extra_adult;
				let costPerExtraChild = accommodation.cost_per_extra_child;
				// Single
				if (accommodation.maximum_guests === 1) {
					let adultCost = costPerRoom * adultCount * days;
					let childrenCost = costPerRoom * childrenCount * days;
					let extraCost =
						(costPerExtraAdult * extraAdults +
							costPerExtraChild * extraChildren) *
						days;
					total = adultCost + childrenCost + extraCost;
					let discountTotal = total * discount;
					total = total - discountTotal;
					if (isNaN(total) === true) {
						total = 0;
					}
					return total;
				} else {
					// Double
					// Twin

					let maxRoomAccommodation = Number(accommodation.maximum_guests);
					let extraPrice =
						(extraAdults * costPerExtraAdult +
							extraChildren * costPerExtraChild) *
						days;
					if (totalGuestsCount % maxRoomAccommodation > 0) {
						total =
							days *
							((totalGuestsCount + 1) / maxRoomAccommodation) *
							costPerRoom;
						total = total + extraPrice;
						total = total - discount * total;
						if (isNaN(total) === true) {
							total = 0;
						}
					} else {
						total =
							days * (totalGuestsCount / maxRoomAccommodation) * costPerRoom;
						total = total + extraPrice;
						total = total - discount * total;
						if (isNaN(total) === true) {
							total = 0;
						}
						return total;
					}
				}
			} else if (
				accommodation.facility_type === "Accomodation" &&
				accommodation.accomodation_type === "Pelican"
			) {
				if ("extra_price" in accommodation) {
					var excessPrice = 0;
					// Check if number exceeds
					if (totalGuestsCount > accommodation.maximum_guests) {
						// Excess number of people
						var excess = totalGuestsCount - accommodation.maximum_guests;
						excessPrice = Number(excess) * Number(accommodation.extra_price);
					}
					var limitPrice = accommodation.special_mandatory_price;
					total = Number(limitPrice) + Number(excessPrice);
					// Calculate with discount total - (Discount/100 * total)
					total = total * days;
					total = total - discount * total;
					return total;
				} else {
					let children = 0;
					let currencyIndex = 0;
					// Self Catered
					if (accommodation.facility_catering_type === "9a9a77eb") {
						accommodation.price[2].lower_limit_list.map(function(price, index) {
							if (
								Number(price.lower_limit) <= Number(totalGuestsCount) &&
								Number(price.upper_limit) >= Number(totalGuestsCount)
							) {
								total = Number(price.price);
								children = Number(price.child_price);
								currencyIndex = index;
							}
						});
						total = this.convert1(
							accommodation.price[2].lower_currency[currencyIndex],
							total
						).amount;
						total = total * days * adultCount;
						total =
							total +
							days *
								this.convert1(
									accommodation.price[2].lower_currency[currencyIndex],
									children
								).amount *
								childrenCount;
						total = total - discount * total;
					} else if (accommodation.facility_catering_type === "266677c3") {
						accommodation.price[0].upper_upper_limit_list.map(function(
							price,
							index
						) {
							if (
								Number(price.lower_limit) <= Number(totalGuestsCount) &&
								Number(price.upper_limit) >= Number(totalGuestsCount)
							) {
								total = Number(price.price);
								children = Number(price.child_price);
								currencyIndex = index;
							}
						});
						total = this.convert1(
							accommodation.price[0].upper_currency[currencyIndex],
							total
						).amount;
						total = total * days * adultCount;
						total =
							total +
							days *
								this.convert1(
									accommodation.price[0].upper_currency[currencyIndex],
									children
								).amount *
								childrenCount;
						total = total - discount * total;
					} else if (accommodation.facility_catering_type === "377788d4") {
						accommodation.price[1].middle_middle_limit_list.map(function(
							price,
							index
						) {
							if (
								Number(price.lower_limit) <= Number(totalGuestsCount) &&
								Number(price.upper_limit) >= Number(totalGuestsCount)
							) {
								total = Number(price.price);
								children = Number(price.child_price);
								currencyIndex = index;
							}
						});
						total = this.convert1(
							accommodation.price[1].upper_currency[currencyIndex],
							total
						).amount;
						total = total * days * adultCount;
						total =
							total +
							days *
								this.convert1(
									accommodation.price[2].upper_currency[currencyIndex],
									children
								).amount *
								childrenCount;
						total = total - discount * total;
					}
					if (isNaN(total) === true) {
						total = 0;
					}
					return total;
				}
			}
			return total;
		},
		addExternalEntry() {
			let facility = this.external_facility.accommodation;
			let facilityData = this.externalFacilityPricing;
			for (let i = 0; i < facilityData.length; i++) {
				if (facilityData[i].parameter_default_value > 0) {
					facilityData[i]["start_date"] = this.external_facility.start_date;
					facilityData[i]["end_date"] = this.external_facility.end_date;
					facilityData[i]["facility_public_id"] = facility.public_id;
					facilityData[i]["name"] = facility.name;
					facilityData[i]["analysis_code"] = facility.analysis_code;
					facilityData[i]["code"] = facility.code;
					facilityData[i]["discount_status"] = facility.discount_status;
					facilityData[i]["discount"] = facility.discount;
					facilityData[i]["is_external"] = 1;
					facilityData[i]["facility_type"] = facility.facility_type_id;
					this.$store.commit("NEW_EXTERNAL_FACILITY", facilityData[i]);
				}
			}
			this.$store.commit("SINGLE_EXTERNAL_FACILITY_PRICE", []);
			this.$store.commit("GET_EXTERNAL_FACILITY_AVAILABILITY", []);
			this.external_facility.start_date = "";
			this.external_facility.end_date = "";
			this.external_facility.accommodation = {};
		},
		confirmExternalBooking() {
			let facilityData = this.addedExternalFacility;
			if (facilityData.length > 0) {
				for (let i = 0; i < facilityData.length; i++) {
					this.$store.commit("CONFIRMED_EXTERNAL_FACILITY", facilityData[i]);
				}
			}
			this.dialog13 = false;
			this.$store.commit("REMOVE_EXTERNAL_FACILITIES", []);
		}
	},
	created() {
		this.$store.dispatch("get_all_facility_pricing_types");
	}
};
</script>

<style scoped></style>
